// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('kiosk_token');
    if (!token) {
        // If no token, redirect to login
        return <Navigate to="/login" replace />;
    }
    return children;
};

export default ProtectedRoute;
